/* eslint-disable */
export const SiglasUnidadeMedida = {
'TONELADA METRICA LIQUIDA': 'TML',
'BIG BAG': 'BG',     
'MICROMETROS': 'MCT',
'PCT': 'PCT',        
'CXS': 'CX',
'PAR': 'PAR',        
'CJ': 'CJ',
'MILHEIRO': 'ML',
'MT': 'MT',
'POTE': 'POTE',
'FOLHAS': 'FL',
'FOLHA': 'FL',
'GARRAFA': 'GF',
'ROLO': 'RL',
'JOGO': 'JG',
'BOBINAS': 'BOB',
'BOBINA': 'BOB',
'DUZIAS': 'DZ',
'LIBRA': 'LIB',
'DISPLAY': 'DP',
'SACO': 'SC',
'DISPLAYS': 'DP',
'FARDOS': 'FDS',
'FARDO': 'FD',
'METROCUBICO': 'M3',
'METROQUADRADO': 'M2',
'PEÃA': 'PC',
'CAIXA DISPLAY': 'CDP',
'BARRIS': 'BAR',
'DUZIA': 'DZ',
'TONELADA MÃTRICA': 'TN',
'CAIXA DE PAPELÃO': 'CX',
'CAIXAS DE PAPELÃO': 'CX',
'METRO LINEAR': 'MTL',
'MILIGRAMAS': 'MG',
'MILILITROSS': 'MIL',
'TONELADAS': 'TO',
'MILIGRAMA': 'MG',
'BARRIL': 'BAR',
'AGULHAS': 'ZPK',
'PALLET': 'PLT',
'LITROS': 'LT',
'BALDE': 'BB',
'PACOTE': 'PT',
'GRAMAS': 'GR',
'UNIDADES': 'UND',
'COPOS': 'CP',
'QUILOGRAMAS': 'KG',
'JARDAS': 'YDS',
'CONJUNTOS': 'CJS',
'MILHEIROS': 'ML',
'METROS': 'MT',
'SACOS': 'SC',
'PACOTES': 'PC',
'ESTOJO PLASTICO': 'EP',
'CONES': 'CONE',
'CONE': 'CONE',
'BARRIL': 'BR',
'PECAS': 'PC',
'CONTAINER': 'CNTR',
'QUILOGRAMA LIQUIDO': 'KG',
'LIBRAS': 'LB',
'JOGOS': 'JG',
'GALAO': 'GL',
'BOLSAS': 'BL',
'ROLOS': 'RL',
'CENTIMETRO': 'CM',
'CAIXA': 'CX',
'QUILOGRAMA': 'KG',
'KIT': 'KT',
'TAMBORES': 'TB',
'TONELADA': 'TON',
'GARRAFAS': 'GF',
'CONJUNTO': 'CJ',
'DÃZIA': 'DZ',
'MEGAWATT HORA': 'MG',
'PARES': 'PAR',
'LITRO': 'LT',
}

export const unidadesMedida = [
  {
    descricao: 'TONELADA METRICA LIQUIDA',
    sigla: 'TML',
  },
  {
    descricao: 'TONELADA METRICA',
    sigla: 'TM',
  },
  {
    descricao: 'BIG BAG',
    sigla: 'BG',
  },
  {
    descricao: 'MICROMETROS',
    sigla: 'MCT',
  },
  {
    descricao: 'PCT',
    sigla: 'PCT',
  },
  {
    descricao: 'CXS',
    sigla: 'CX',
  },
  {
    descricao: 'PAR',
    sigla: 'PAR',
  },
  {
    descricao: 'CJ',
    sigla: 'CJ',
  },
  {
    descricao: 'MILHEIRO',
    sigla: 'ML',
  },
  {
    descricao: 'MT',
    sigla: 'MT',
  },
  {
    descricao: 'POTE',
    sigla: 'POTE',
  },
  {
    descricao: 'FOLHAS',
    sigla: 'FL',
  },
  {
    descricao: 'FOLHA',
    sigla: 'FL',
  },
  {
    descricao: 'GARRAFA',
    sigla: 'GF',
  },
  {
    descricao: 'ROLO',
    sigla: 'RL',
  },
  {
    descricao: 'JOGO',
    sigla: 'JG',
  },
  {
    descricao: 'BOBINAS',
    sigla: 'BOB',
  },
  {
    descricao: 'BOBINA',
    sigla: 'BOB',
  },
  {
    descricao: 'DUZIAS',
    sigla: 'DZ',
  },
  {
    descricao: 'LIBRA',
    sigla: 'LIB',
  },
  {
    descricao: 'DISPLAY',
    sigla: 'DP',
  },
  {
    descricao: 'SACO',
    sigla: 'SC',
  },
  {
    descricao: 'DISPLAYS',
    sigla: 'DP',
  },
  {
    descricao: 'FARDOS',
    sigla: 'FDS',
  },
  {
    descricao: 'FARDO',
    sigla: 'FD',
  },
  {
    descricao: 'METROCUBICO',
    sigla: 'M3',
  },
  {
    descricao: 'METROQUADRADO',
    sigla: 'M2',
  },
  {
    descricao: 'PEÇA',
    sigla: 'PC',
  },
  {
    descricao: 'CAIXA DISPLAY',
    sigla: 'CDP',
  },
  {
    descricao: 'BARRIS',
    sigla: 'BAR',
  },
  {
    descricao: 'DUZIA',
    sigla: 'DZ',
  },
  {
    descricao: 'TONELADA MÉTRICA',
    sigla: 'TN',
  },
  {
    descricao: 'CAIXA DE PAPELÃO',
    sigla: 'CX',
  },
  {
    descricao: 'CAIXAS DE PAPELÃO',
    sigla: 'CX',
  },
  {
    descricao: 'METRO LINEAR',
    sigla: 'MTL',
  },
  {
    descricao: 'MILIGRAMAS',
    sigla: 'MG',
  },
  {
    descricao: 'MILILITROSS',
    sigla: 'MIL',
  },
  {
    descricao: 'TONELADAS',
    sigla: 'TO',
  },
  {
    descricao: 'MILIGRAMA',
    sigla: 'MG',
  },
  {
    descricao: 'BARRIL',
    sigla: 'BAR',
  },
  {
    descricao: 'AGULHAS',
    sigla: 'ZPK',
  },
  {
    descricao: 'PALLET',
    sigla: 'PLT',
  },
  {
    descricao: 'LITROS',
    sigla: 'LT',
  },
  {
    descricao: 'BALDE',
    sigla: 'BB',
  },
  {
    descricao: 'PACOTE',
    sigla: 'PT',
  },
  {
    descricao: 'GRAMAS',
    sigla: 'GR',
  },
  {
    descricao: 'UNIDADES',
    sigla: 'UND',
  },
  {
    descricao: 'COPOS',
    sigla: 'CP',
  },
  {
    descricao: 'QUILOGRAMAS',
    sigla: 'KG',
  },
  {
    descricao: 'JARDAS',
    sigla: 'YDS',
  },
  {
    descricao: 'CONJUNTOS',
    sigla: 'CJS',
  },
  {
    descricao: 'MILHEIROS',
    sigla: 'ML',
  },
  {
    descricao: 'METROS',
    sigla: 'MT',
  },
  {
    descricao: 'SACOS',
    sigla: 'SC',
  },
  {
    descricao: 'PACOTES',
    sigla: 'PC',
  },
  {
    descricao: 'ESTOJO PLASTICO',
    sigla: 'EP',
  },
  {
    descricao: 'CONES',
    sigla: 'CONE',
  },
  {
    descricao: 'CONE',
    sigla: 'CONE',
  },
  {
    descricao: 'BARRIL',
    sigla: 'BR',
  },
  {
    descricao: 'PECAS',
    sigla: 'PC',
  },
  {
    descricao: 'CONTAINER',
    sigla: 'CNTR',
  },
  {
    descricao: 'QUILOGRAMA LIQUIDO',
    sigla: 'KG',
  },
  {
    descricao: 'LIBRAS',
    sigla: 'LB',
  },
  {
    descricao: 'JOGOS',
    sigla: 'JG',
  },
  {
    descricao: 'GALAO',
    sigla: 'GL',
  },
  {
    descricao: 'BOLSAS',
    sigla: 'BL',
  },
  {
    descricao: 'ROLOS',
    sigla: 'RL',
  },
  {
    descricao: 'CENTIMETRO',
    sigla: 'CM',
  },
  {
    descricao: 'CAIXA',
    sigla: 'CX',
  },
  {
    descricao: 'QUILOGRAMA',
    sigla: 'KG',
  },
  {
    descricao: 'KIT',
    sigla: 'KT',
  },
  {
    descricao: 'TAMBORES',
    sigla: 'TB',
  },
  {
    descricao: 'TONELADA',
    sigla: 'TON',
  },
  {
    descricao: 'GARRAFAS',
    sigla: 'GF',
  },
  {
    descricao: 'CONJUNTO',
    sigla: 'CJ',
  },
  {
    descricao: 'DÚZIA',
    sigla: 'DZ',
  },
  {
    descricao: 'MEGAWATT HORA',
    sigla: 'MG',
  },
  {
    descricao: 'PARES',
    sigla: 'PAR',
  },
  {
    descricao: 'LITRO',
    sigla: 'LT',
  },
]